import React from 'react';

export const Warning = ({ width = '38', height = '38', fill = 'black' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_12504)">
        <path
          d="M18.9107 0C8.4835 0 0 8.5234 0 19C0 29.4766 8.5234 38 19 38C29.4766 38 38 29.4766 38 19C38 8.5234 29.4367 0 18.9107 0ZM19 34.2C10.6191 34.2 3.8 27.3809 3.8 19C3.8 10.6191 10.5773 3.8 18.9107 3.8C27.3429 3.8 34.2 10.6191 34.2 19C34.2 27.3809 27.3809 34.2 19 34.2Z"
          fill={fill}
        />
        <path
          d="M17.0996 9.5H20.8996V22.8H17.0996V9.5ZM17.0996 24.7H20.8996V28.5H17.0996V24.7Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_12504">
          <rect width="38" height="38" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
